import {
	corSeveridade,
	corTipoEvento,
} from "../../../utils/centralDeAlertas/cores";

const styles = (theme) => ({
	// Linha do cabeçalho: título/legenda à esquerda, botão ⓘ à direita.
	linhaCabecalho: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
	},
	container: {
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
		width: "100%",
		height: "100%",
		// Teto do card; a lista rola por dentro.
		maxHeight: "500px",
		borderRadius: "10px",
		p: "16px",
		overflow: "hidden",
	},
	// Preenche o espaço restante do Paper (altura fixa da linha vem da página,
	// itemAlturaFeeds) e rola por dentro.
	listaEventos: {
		position: "relative",
		flexGrow: 1,
		minHeight: 0,
		overflowY: "auto",
		pr: "4px",
	},
	cabecalhoDia: {
		position: "sticky",
		top: 0,
		zIndex: 1,
		bgcolor: theme.palette.background.paper,
		py: "6px",
	},
	textoCabecalhoDia: {
		color: theme.palette.text.secondary,
		fontWeight: 600,
		fontSize: "0.68rem",
		textTransform: "uppercase",
		letterSpacing: "0.06em",
	},
	linhaEvento: (clicavel) => ({
		display: "grid",
		gridTemplateColumns: "18px 40px minmax(0, 1fr) 8px",
		alignItems: "center",
		gap: 1,
		py: "6px",
		px: "4px",
		borderTop: `1px solid ${theme.palette.divider}`,
		cursor: clicavel ? "pointer" : "default",
		...(clicavel && {
			"&:hover": {
				backgroundColor: theme.palette.action.hover,
			},
		}),
	}),
	iconeEvento: (tipo) => ({
		color: corTipoEvento(theme, tipo),
		fontSize: "16px",
	}),
	hora: {
		color: theme.palette.text.secondary,
		fontVariantNumeric: "tabular-nums",
	},
	textoOrigem: {
		color: theme.palette.text.primary,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	textoTipo: {
		color: theme.palette.text.secondary,
	},
	// Sem severidade (atendimento/OS) o ponto fica transparente.
	pontoSeveridade: (severidade) => ({
		width: "8px",
		height: "8px",
		borderRadius: "50%",
		backgroundColor:
			severidade != null ? corSeveridade(theme, severidade) : "transparent",
	}),
	rodapePaginacao: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 0.5,
		py: "10px",
	},
	textoPaginacao: {
		color: theme.palette.text.secondary,
	},
	botaoCarregarMais: {
		textTransform: "none",
	},
	estadoVazio: {
		flexGrow: 1,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		py: "48px",
	},
	skeletonLinha: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
		py: "8px",
	},
	skeletonTextos: {
		flexGrow: 1,
	},
});

export default styles;
